<template>
  <div>
    <div class="title">
        <div style="width: 500px;margin: 0 auto;height: 500px;line-height: 500px;text-align: center;font-size: 30px;">欢迎访问系统！</div>
    </div>
  </div>
</template>

<script>
import {
  getTopIndex,
  getTodoEvent,
  getProfitChart,
  getNewUsersChart,
  getNewOrderChart,
  getRiddingRankingByDayRentOrder,
  getNewDayRentOrderChart,
  getRiddingRanking,
  getBikeProfitRanking,
  getUserPhoneChart,
} from '@/api/index'
import LineChart from './components/LineChart'
import ManyLineChart from './components/ManyLineChart'
import PieChart from './components/PieChart'
import {indexAreas} from '@/api/area'
import {getMerchant} from '@/api/area'
import env from '../../env'
export default {
  name: 'Index',
  components: {
    LineChart,
    PieChart,
    ManyLineChart,
  },
  data() {
    return {
      isPosSwitch:env.isPosSwitch,
      options: [{
        value: '',
        label: '全部区域',
      }],
      area_id: '',
   select_id:"",
      merchart:[{
        value: '',
        label: '全部商户',
      }],
      merchart_id:'',
      top: {
        new_order: {
          new_num: 0, // 新订单数量
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_user: {
          total_num: 0,
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_order: {
          total_num: 0,
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
        total_profit: {
          total_num: 0,
          diff: 2, // 增长情况
          difference: 0, // 实际增长数量
        },
      },
      todo_event: {
        low_battery_num: 0, // 低电量
        long_time_no_ridding: 0, // 24小时未骑车辆
        long_time_no_return_ridding: 0, // 24小时未还车
        trouble_num: 0, // 故障车辆
        warning_num: 0, // 报警数量
      },
      profitChart: {
        expectedData: {
          data: [],
          date: [],
          legendData: [],
        },
      },
      newUsersChart: {
        expectedData: {
          data: [],
          date: [],
          legendData: [],
        },
      },
      orderType: 'nomal',
      newOrderChartData: {
        expectedData: {
          data: [],
          date: [],
          legendData: [],
        },
      },
      platformPieChart: {
        expectedData: {
          title: '终端比例',
          data: [],
        },
      },
      userPhoneData: [],
      tableData: [],
      BikeProfitRanking: [],
    }
  },
  created() {
    // console.log(222)
    // this.getAreas()
    // this.initData()
    // this.getMerchant()
  },
  methods: {
    seChange() {
      var params = {}
      if (this.area_id !== '') {
        params = { area_id: this.area_id }
      }
      console.log(this.area_id,"00000")
      this.initData(params)
    },
merChange(){
this.options=[]
if(this.merchart_id==""){
  this.initData()
  this.area_id=""
  console.log("这是商户id为空的时候")
}else{
 this.getAreas1()

}

//   console.log(this.select_id,)
//   // var params = {}
//       // if (this.merchart_id !== '') {
//       //   params = { merchart_id: this.merchart_id }
//       // }
//       this.options=[{}]
//       this.getAreas()

//       console.log(this.options,"9999")
//       // let select_id=this.options[0].value

//       // this.area_id=select_id
//           // var params = { area_id: this.area_id}

//           //    this.initData(params)

// console.log(this.select_id,"55555")


},
    async getAreas() {
      const [
        { data: areas },
      ] = await Promise.all([
          indexAreas({merchant_id: this.merchart_id}),
      ])

      areas.map(i => {
        this.options.push({ value: i.id, label: i.name })
      })

    },
     async getAreas1() {
      const [
        { data: areas },
      ] = await Promise.all([
          indexAreas({all: 1, merchant_id: this.merchart_id}),
      ])

      areas.map(i => {
        this.options.push({ value: i.id, label: i.name })
      })
      console.log(this.options,"6776777778")
      this.area_id=this.options[0].value
      console.log(this.area_id,"yuyuuyuui")
      var params={area_id: this.area_id , merchant_id:this.merchart_id}
      this.initData(params)

     },
    async getMerchant(){
      const[
        { data:merchart},
      ]=await Promise.all([
        getMerchant({}),
      ])
      merchart.map(j=>{
         this.merchart.push({value:j.id,label:j.name})
      })
    },
    clearData() {
      this.profitChart.expectedData.data = []
      this.profitChart.expectedData.date = []
      this.profitChart.expectedData.legendData = []

      this.newUsersChart.expectedData.data = []
      this.newUsersChart.expectedData.date = []
      this.newUsersChart.expectedData.legendData = []
      this.newOrderChartData.expectedData.data = []
      this.newOrderChartData.expectedData.date = []
      this.newOrderChartData.expectedData.legendData = []

      this.platformPieChart.expectedData.data = []
    },
    async initData(params = {}) {
      this.clearData()
      // 头部统计
      const [{ data: top }] = await Promise.all([getTopIndex(params)])
      this.top = top

      // 待办事项统计
      const [{ data: todoEvent }] = await Promise.all([getTodoEvent(params)])
      this.todo_event = todoEvent

      // 总收益折线图
      var profitParams = { days: 'thirtyDays' }
      if (params !== {}) {
        profitParams = { days: 'thirtyDays', area_id: params.area_id , merchant_id:this.merchart_id }
      }
      const [{ data: profitChart }] = await Promise.all([
        getProfitChart(profitParams),
      ])
      profitChart.map(i => {
        this.profitChart.expectedData.legendData.push(i.name)
        let arr = []
        let date = []
        i.data.map(e => {
          arr.push(e.value)
          date.push(e.date)
        })
        this.profitChart.expectedData.data.push(arr)
        this.profitChart.expectedData.date = date
      })

      console.log(this.profitChart.expectedData.data)
      // 新增用户折线图

      var newUsersParams = { days: 'thirtyDays' }
      if (params !== {}) {
        newUsersParams = { days: 'thirtyDays', area_id: params.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: newUserChart }] = await Promise.all([
        getNewUsersChart(newUsersParams),
      ])
      newUserChart.map(i => {
        this.newUsersChart.expectedData.legendData.push(i.name)
        let arr = []
        let date = []
        i.data.map(e => {
          arr.push(e.value)
          date.push(e.date)
        })
        this.newUsersChart.expectedData.data.push(arr)
        this.newUsersChart.expectedData.date = date
      })

      // 新订单折线图
      var newOrderParams = { days: 'thirtyDays' }
      if (params !== {}) {
        newOrderParams = { days: 'thirtyDays', area_id: params.area_id, merchant_id:this.merchart_id }
      }
      const [{ data: newOrderChart }] = await Promise.all([
        getNewOrderChart(newOrderParams),
      ])

      newOrderChart.map(i => {
        this.newOrderChartData.expectedData.legendData.push(i.name)
        let arr = []
          let date = []
          i.data.map(e => {
              arr.push(e.value)
              date.push(e.date)
          })
          this.newOrderChartData.expectedData.data.push(arr)
          this.newOrderChartData.expectedData.date = date
      })

        // 排行榜
        var rankingParams = {days: 'oneMonth'}
        if (params !== {}) {
            rankingParams = {days: 'oneMonth', area_id: params.area_id, merchant_id: this.merchart_id}
        }
        // const [{ data: riddingRanking }] = await Promise.all([
        //   getRiddingRanking(rankingParams),
        // ])
        // this.tableData = riddingRanking
        const [{data: BikeProfitRanking}] = await Promise.all([
            getBikeProfitRanking(rankingParams),
        ])
        this.BikeProfitRanking = BikeProfitRanking
        // 手机分析
        var userPhoneParams = {days: 'sixMonth'}
        if (params !== {}) {
            userPhoneParams = {days: 'sixMonth', area_id: params.area_id, merchant_id: this.merchart_id}
        }
        const [{data: userPhone}] = await Promise.all([
            getUserPhoneChart(userPhoneParams),
        ])
        this.userPhoneData = userPhone.userPhone
        this.platformPieChart.expectedData.data = userPhone.platform
    },
    changeNewOrderType(type) {
      this.orderType = type
      this.newOrderChartChange('fifteenDays')
    },
    changeOrderTypeRiddingRanking(type) {
      this.orderType = type
      this.riddingRankingChange('oneMonth')
    },
    async newOrderChartChange(day) {
      this.newOrderChartData.expectedData.data = []
      this.newOrderChartData.expectedData.date = []
      this.newOrderChartData.expectedData.legendData = []
      var newOrderParams = { days: day }
      if (this.area_id !== '') {
        newOrderParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      if (this.orderType == 'nomal') {
        const [{ data: newOrderChart }] = await Promise.all([
          getNewOrderChart(newOrderParams),
        ])

        newOrderChart.map(i => {
          this.newOrderChartData.expectedData.legendData.push(i.name)
          let arr = []
          let date = []
          i.data.map(e => {
            arr.push(e.value)
            date.push(e.date)
          })
          this.newOrderChartData.expectedData.data.push(arr)
          this.newOrderChartData.expectedData.date = date
        })
      } else if (this.orderType == 'dayRent') {
        const [{ data: newOrderChart }] = await Promise.all([
          getNewDayRentOrderChart(newOrderParams),
        ])

        newOrderChart.map(i => {
          this.newOrderChartData.expectedData.legendData.push(i.name)
          let arr = []
          let date = []
          i.data.map(e => {
            arr.push(e.value)
            date.push(e.date)
          })
          this.newOrderChartData.expectedData.data.push(arr)
          this.newOrderChartData.expectedData.date = date
        })
      }
    },
    async profitChartChange(day) {
      this.profitChart.expectedData.data = []
      this.profitChart.expectedData.date = []
      this.profitChart.expectedData.legendData = []

      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: profitChart }] = await Promise.all([
        getProfitChart(profitParams),
      ])
      // let ordersCahrtData = []
      profitChart.map(i => {
        this.profitChart.expectedData.legendData.push(i.name)
        let arr = []
        let date = []
        i.data.map(e => {
          arr.push(e.value)
          date.push(e.date)
        })
        this.profitChart.expectedData.data.push(arr)
        this.profitChart.expectedData.date = date
      })
      // profitChart.ordersCahrt.data.map(i => {
      //   ordersCahrtData.push(i.value)
      //   this.profitChart.expectedData.date.push(i.date)
      // })
      // let rechargeOrdersChartData = []
      // profitChart.rechargeOrdersChart.data.map(i => { rechargeOrdersChartData.push(i.value) })
      // let cardRidingOrdersChartData = []
      // profitChart.cardRidingOrdersChart.data.map(i => { cardRidingOrdersChartData.push(i.value) })
      // let depositCardOrdersChartData = []
      // profitChart.depositCardOrdersChart.data.map(i => { depositCardOrdersChartData.push(i.value) })
      // this.profitChart.expectedData.data = {
      //   ordersCahrtData,
      //   rechargeOrdersChartData,
      //   cardRidingOrdersChartData,
      //   depositCardOrdersChartData,
      // }
    },
    async newUsersChartChange(day) {
      this.newUsersChart.expectedData.data = []
      this.newUsersChart.expectedData.date = []
      this.newUsersChart.expectedData.legendData = []
      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: newUsersCharts }] = await Promise.all([
        getNewUsersChart(profitParams),
      ])
      newUsersCharts.map(i => {
        this.newUsersChart.expectedData.legendData.push(i.name)
        let arr = []
        let date = []
        i.data.map(e => {
          arr.push(e.value)
          date.push(e.date)
        })
        this.newUsersChart.expectedData.data.push(arr)
        this.newUsersChart.expectedData.date = date
      })
    },
    async riddingRankingChange(day) {
      this.tableData = []
      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id }
      }
      // 排行榜
      if (this.orderType == 'nomal') {
        const [{ data: riddingRanking }] = await Promise.all([
          getRiddingRanking(profitParams),
        ])
        this.tableData = riddingRanking
      } else if (this.orderType == 'dayRent') {
        const [{ data: riddingRanking }] = await Promise.all([
          getRiddingRankingByDayRentOrder(profitParams),
        ])
        this.tableData = riddingRanking
      }

      // console.log(riddingRanking)
    },
    async phoneAnalize(day) {
      this.userPhoneData = []
      // 排行榜
      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: userPhone }] = await Promise.all([
        getUserPhoneChart(profitParams),
      ])
      this.userPhoneData = userPhone.userPhone
      this.platformPieChart.expectedData.data = userPhone.platform
      // console.log(riddingRanking)
    },

    async bikeProfitRankingChange(day) {
      // 排行榜
      var profitParams = { days: day }
      if (this.area_id !== '') {
        profitParams = { days: day, area_id: this.area_id , merchant_id:this.merchart_id}
      }
      const [{ data: riddingRanking }] = await Promise.all([
        getBikeProfitRanking(profitParams),
      ])
      this.BikeProfitRanking = riddingRanking
      // console.log(riddingRanking)
    },
  },
}
</script>

<style lang="scss" scope>
.title {

    justify-content: space-between;
  margin-left: 10px;
  .wid_l {
    width: 200px;
    margin: 10px 0 0 10px;
  }
   .wid_2 {
    width: 200px;
   margin: 10px 0 0 10px;
  }
}
.top-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 20px;
  .top-card {
    width: 22%;
    height: 108px;
    font-size: 12px;
    color: #666;
    .top-info1 {
      display: flex;
      justify-content: space-between;
      .svg-position {
        padding-left: 10px;
        .svg-class {
          width: 45px;
          height: 45px;
        }
      }
      .content-info {
        text-align: center;
        line-height: 18px;
        color: rgba(50, 50, 50, 0.9);
        font-size: 17px;
        margin-top: 12px;
      }
      .top-item-info1 {
        span {
          display: block;
          text-align: right;
          font-weight: 700;
          font-size: 28px;
        }

        .card-panel-change-text {
          display: inline;
          font-size: 0.8rem;
          margin-right: 5px;
          left: -80px;
          top: 3px;
        }
        .change-num {
          float: right;
          text-align: right;
          margin-top: 15px;
          font-size: 16px;
          display: inline-block;
        }
      }
    }
  }
}
.mid-div {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  .todo-event {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    width: 90%;
    p {
      text-align: center;
      font-size: 1.4rem;
      margin: 5px auto;
    }
    .red-class {
      color: red;
    }
    span {
      color: #6f7180;
      font-size: 0.9rem;
    }
  }
  .todo-title {
    color: #36a3f7;
    font-size: 1.2rem;
    // padding-top: 15px;
  }
  .profit-statistic {
    .title-select {
      display: flex;
      justify-content: space-between;
    }
  }
  .top-mar {
    margin-top: 30px;
  }
}
.buttom-div {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  .ranking-card {
    width: 23%;
    .title-select {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .todo-title {
        color: #36a3f7;
        font-size: 1.2rem;
        // padding-top: 15px;
      }
      .rightr {
        float: right;
      }
      .top-bu {
        margin-top: 10px;
      }
    }
  }
  .user-phone {
      width: 49%;

      .title-select {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;

          .todo-title {
              color: #36a3f7;
              font-size: 1.2rem;
              // padding-top: 15px;
          }
      }
    .table_and_chart {
      display: flex;
      justify-content: space-between;
      .chart-platform {
        width: 35%;
      }
      .min-title {
        text-align: center;
        font-size: 1.1rem;
        margin-bottom: 10px;
      }
      .table-phone {
        width: 60%;
      }
    }
  }
  .bikes-profit-card {
      width: 49%;

      .title-select {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;

          .todo-title {
              color: #36a3f7;
              font-size: 1.2rem;
              // padding-top: 15px;
          }
      }
  }
}
</style>
